import * as THREE from "three";
// @ts-ignore
import vertexShader from "bundle-text:./ArrowField.vertex.glsl";
// @ts-ignore
import fragmentShader from "bundle-text:./ArrowField.fragment.glsl";

export default class ArrowField extends THREE.Mesh {
  centerBuffer: THREE.InstancedBufferAttribute;
  directionBuffer: THREE.InstancedBufferAttribute;
  // @ts-ignore
  centerSAB: SharedArrayBuffer | undefined;
  // @ts-ignore
  directionSAB: SharedArrayBuffer | undefined;

  constructor(
    maxInstances: number,
    radius: number = 0.05,
    headLength: number = 0.3,
    headRadius: number = 0.15,
    segments = 8,
    useSharedArrayBuffer = false
  ) {
    const instancedGeometry = new THREE.InstancedBufferGeometry();

    const indices = [];
    const vertices = [];
    const normals = [];

    const headNormalNorm = Math.hypot(headRadius, headLength);
    const headNormalXZ = headLength / headNormalNorm;
    const headNormalY = headRadius / headNormalNorm;

    vertices.push(0, 0, 0);
    normals.push(0, -1, 0);
    vertices.push(0, 1, 0);
    normals.push(0, 1, 0);
    for (let i = 0; i < segments; ++i) {
      const angle = (Math.PI * 2 * (i + 0.5)) / segments;
      const x = Math.cos(angle);
      const z = Math.sin(angle);

      vertices.push(radius * x, 0, radius * z);
      normals.push(0, -1, 0);

      vertices.push(radius * x, 0, radius * z);
      normals.push(x, 0, z);
      vertices.push(radius * x, 1 - headLength, radius * z);
      normals.push(x, 0, z);

      vertices.push(radius * x, 1 - headLength, radius * z);
      normals.push(0, -1, 0);
      vertices.push(headRadius * x, 1 - headLength, headRadius * z);
      normals.push(0, -1, 0);

      vertices.push(headRadius * x, 1 - headLength, headRadius * z);
      normals.push(headNormalXZ * x, headNormalY, headNormalXZ * z);

      const j = (i + 1) % segments;
      indices.push(0, 2 + 6 * i, 2 + 6 * j);

      indices.push(3 + 6 * i, 4 + 6 * i, 3 + 6 * j);
      indices.push(4 + 6 * i, 4 + 6 * j, 3 + 6 * j);

      indices.push(5 + 6 * i, 6 + 6 * i, 5 + 6 * j);
      indices.push(6 + 6 * i, 6 + 6 * j, 5 + 6 * j);

      indices.push(1, 7 + 6 * j, 7 + 6 * i);
    }

    instancedGeometry.setIndex(new THREE.Uint16BufferAttribute(indices, 1));
    instancedGeometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(vertices, 3)
    );
    instancedGeometry.setAttribute(
      "normal",
      new THREE.Float32BufferAttribute(normals, 3)
    );

    let centerBufferArray, directionBufferArray;
    let centerSAB = undefined;
    let directionSAB = undefined;
    if (useSharedArrayBuffer) {
      centerBufferArray = new Float32Array(
        //@ts-ignore
        (centerSAB = new SharedArrayBuffer(12 * maxInstances))
      );
      directionBufferArray = new Float32Array(
        //@ts-ignore
        (directionSAB = new SharedArrayBuffer(12 * maxInstances))
      );
    } else {
      centerBufferArray = new Float32Array(maxInstances * 3);
      directionBufferArray = new Float32Array(maxInstances * 3);
    }
    const centerBuffer = new THREE.InstancedBufferAttribute(
      centerBufferArray,
      3
    );
    const directionBuffer = new THREE.InstancedBufferAttribute(
      directionBufferArray,
      3
    );
    directionBuffer.setUsage(THREE.DynamicDrawUsage);
    instancedGeometry.setAttribute("center", centerBuffer);
    instancedGeometry.setAttribute("direction", directionBuffer);
    instancedGeometry.instanceCount = maxInstances;
    // Weird fix but essential
    (instancedGeometry as any)._maxInstanceCount = maxInstances;

    const material = new THREE.RawShaderMaterial({
      uniforms: {
        arrow_scale: { value: 1.0 },
        max_length: { value: -1.0 },
      },
      vertexShader: vertexShader,
      fragmentShader: fragmentShader,
    });

    super(instancedGeometry, material);
    this.centerBuffer = centerBuffer;
    this.directionBuffer = directionBuffer;
    this.centerSAB = centerSAB;
    this.directionSAB = directionSAB;
    this.frustumCulled = false;
  }

  set instanceCount(value: number) {
    (this.geometry as THREE.InstancedBufferGeometry).instanceCount = value;
  }

  set arrowScale(value: number) {
    (this.material as THREE.RawShaderMaterial).uniforms[
      "arrow_scale"
    ].value = value;
  }

  set maxLength(value: number) {
    (this.material as THREE.RawShaderMaterial).uniforms[
      "max_length"
    ].value = value;
  }

  setCenter(data: ArrayLike<number>, offset: number = 0) {
    (this.centerBuffer.array as Float32Array).set(data, 3 * offset);
    this.centerBuffer.needsUpdate = true;
  }

  setDirection(data: ArrayLike<number>, offset: number = 0) {
    (this.directionBuffer.array as Float32Array).set(data, 3 * offset);
    this.directionBuffer.needsUpdate = true;
  }
}
